/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Our database contains info from multiple sources. These identifiers can be used to either limit search results or to determine the relevance of a result.
 * @export
 */
export const GeocodingSource = {
  Openstreetmap: "openstreetmap",
  Openaddresses: "openaddresses",
  Whosonfirst: "whosonfirst",
  Geonames: "geonames",
  Foursquare: "foursquare",
} as const;
export type GeocodingSource =
  (typeof GeocodingSource)[keyof typeof GeocodingSource];

export function instanceOfGeocodingSource(value: any): boolean {
  for (const key in GeocodingSource) {
    if (Object.prototype.hasOwnProperty.call(GeocodingSource, key)) {
      if (GeocodingSource[key as keyof typeof GeocodingSource] === value) {
        return true;
      }
    }
  }
  return false;
}

export function GeocodingSourceFromJSON(json: any): GeocodingSource {
  return GeocodingSourceFromJSONTyped(json, false);
}

export function GeocodingSourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeocodingSource {
  return json as GeocodingSource;
}

export function GeocodingSourceToJSON(value?: GeocodingSource | null): any {
  return value as any;
}

export function GeocodingSourceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GeocodingSource {
  return value as GeocodingSource;
}
